/**
 * Shared by the list and the report view, which both wait out the same pass from different pages.
 * Generation runs in the report service's background, so neither page learns anything by asking
 * more often than the service works.
 */
export const GENERATING_POLL_INTERVAL_MS = 5000;

/**
 * A pass takes 15-90 seconds, so anything past this is not a slow report, it is a stuck one. The
 * service has no watchdog that moves an abandoned pass to Failed, so without a stop a page would
 * keep hitting the endpoint every five seconds for as long as the tab stays open, for a status that
 * is never going to change on its own.
 */
export const GENERATING_POLL_TIMEOUT_MS = 5 * 60 * 1000;
